export const SITE_NAME = "The Birchwood Academy";

const isLocalHost =
  typeof window === "undefined" ||
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const API_ORIGIN = isLocalHost
  ? "http://localhost:3031"
  : "https://api.thebirchwoodacademy.com";

export const BASE_URL = `${API_ORIGIN}/api`;
export const UPLOADS_URL = `${API_ORIGIN}/Uploads`;
export const SOCKET_URL = `${API_ORIGIN}/`;

export const AUTH = {
  signin: "/admin/auth/signin",
  register: "/admin/auth/register",
  updateProfile: "/admin/auth/updateProfile",
  changePassword: "/admin/auth/changePassword",
  emailCode: "/admin/auth/emailVerificationCode",
  verifyCode: "/admin/auth/verifyRecoverCode",
  resetPassword: "/admin/auth/resetPassword",
  logout: "/admin/auth/logout",
};

export const ADMIN = {
  dashboardOverview: "/admin/dashboard/overview",
};

export const POST = {
  addPost: "/post/addPost",
  getAllPosts: "/post/getAllPosts",
  getPostById: "/post/getPostById/",
  updatePost: "/post/updatePost/",
  deletePost: "/post/deletePost/",
  getAllClassPosts: "/post/getAllClassPosts/",
  getAllChildPosts: "/post/getAllChildPosts/",
  getAllPostComments: "/post/getAllPostComments/",
  getPostLikes: "/post/getPostLikes/",
  deleteComment: "/post/deleteComment/",
  removeLike: "/post/removeLike/",
};

export const NOTIFICATION = {
  get: "/notification/getAllAdminNotifications",
  getUnreadAdminNotifications: "/notification/getUnreadAdminNotifications",
  getOne: "/notification/notificationDetail/",
  create: "/notification/createAlertOrAnnoucement",
  update: "/notification/updateNotification/",
  markAsRead: "/notification/markAsRead/",
  markAllAsRead: "/notification/markAllAsRead",
  delete: "/notification/deleteNotification/",
};

export const SUPPORT = {
  createTicket: "/support/createTicket",
  getAllTickets: "/support/getAllTickets",
  getUnreadCount: "/support/getUnreadTicketCount",
  getTicketById: "/support/getTicketById/",
  updateTicket: "/support/updateTicket/",
  getMessages: "/support/getTicketMessages/",
  sendMessage: "/support/sendMessage/",
  markRead: "/support/markTicketRead/",
  verifyAccess: "/support/verifyTicketAccess/",
};

export const FEES = {
  createVoucher: "/fees/createVoucher",
  getAllVouchers: "/fees/getAllVouchers",
  getVoucherById: "/fees/getVoucherById/",
  getAllChildVouchers: "/fees/getAllChildVouchers/",
  updateVoucher: "/fees/updateVoucher/",
  previewMonth: "/fees/previewMonth",
  sendMonth: "/fees/sendMonth",
  review: "/fees/review/",
  toggleStatus: "/fees/toggleStatus/",
  deleteVoucher: "/fees/deleteVoucher/",
};

export const HOMEWORK = {
  addHomework: "/homework/addHomework",
  getAllHomework: "/homework/getAllHomework",
  getHomeworkById: "/homework/getHomeworkById/",
  getAllChildHomework: "/homework/getAllChildHomework/",
  updateHomework: "/homework/updateHomework/",
  deleteHomework: "/homework/deleteHomework/",
};

export const CONTENT_TYPE = {
  JSON: "application/json",
  FORM_DATA: "multipart/form-data",
};

export const TEACHERS = {
  getAllTeachers: "/admin/teacher/getAllTeachers",
  updateTeacher: "/admin/teacher/updateTeacher/",
  getTeacherById: "/admin/teacher/getTeacherById/",
  deleteTeacher: "/admin/teacher/deleteTeacher/",
  addTeacher: "/admin/teacher/addTeacher",
  getTeacherAttendanceByMonth: "/admin/teacher/getTeacherAttendanceByMonth/",
  resetTeacherPassword: "/admin/teacher/resetTeacherPassword/",
  markAttendance: "/admin/teacher/markAttendance/",
  updateAttendance: "/admin/teacher/updateAttendance/",
  deleteAttendance: "/admin/teacher/deleteAttendance/",
  searchClassrooms: "/admin/teacher/searchClassrooms",
};

export const PARENTS = {
  getAllParents: "/admin/parent/getAllParent",
  searchStudents: "/admin/parent/searchStudents",
  addParent: "/admin/parent/addParent",
  getParentById: "/admin/parent/getParentById/",
  updateParent: "/admin/parent/updateParent/",
  toggleStatus: "/admin/parent/toggleStatus/",
  deleteParent: "/admin/parent/deleteParent/",
  getParentAttendanceByMonth: "/admin/parent/getParentAttendanceByMonth/",
  resetParentPassword: "/admin/parent/resetParentPassword/",
  markAttendance: "/admin/parent/markAttendance/",
  updateAttendance: "/admin/parent/updateAttendance/",
  deleteAttendance: "/admin/parent/deleteAttendance/",
};

export const CHILDREN = {
  getAllChildren: "/admin/children/getAllChildren",
  searchParents: "/admin/children/searchParents",
  addChild: "/admin/children/addChild",
  updateChild: "/admin/children/updateChild/",
  getChildById: "/admin/children/getChildById/",
  getChildAttendanceByMonth: "/admin/children/getAttendanceByMonth/",
  markChildAttendance: "/admin/children/markAttendance/",
  updateChildAttendance: "/admin/children/updateAttendance/",
  deleteChildAttendance: "/admin/children/deleteAttendance/",
  deleteChild: "/admin/children/deleteChild/",
  toggleStatus: "/admin/children/toggleStatus/",
};

export const CLASSROOM = {
  getAllClassrooms: "/classroom/getAllClassrooms",
  getClassroomById: "/classroom/getClassroomById/",
  searchTeachers: "/classroom/searchTeachers",
  searchParents: "/admin/children/searchParents",
  addClassroom: "/classroom/addClassroom",
  updateClass: "/classroom/updateClassroom/",
  deleteClass: "/classroom/deleteClassroom/",
};

export const TIMETABLE = {
  getAllClassTimetables: "/timetable/getAllClassTimetables/",
};

export const INVENTORY = {
  addInventory: "/inventory/addInventory",
  getAllInventorys: "/inventory/getAllInventorys",
  getInventoryById: "/inventory/getInventoryById/",
  updateInventory: "/inventory/updateInventory/",
  toggleStatus: "/inventory/toggleStatus/",
  deleteInventory: "/inventory/deleteInventory/",
  issueStock: "/inventory/issueStock/",
  removeIssuance: "/inventory/removeIssuance/",
};

export const HOLIDAY = {
  addHoliday: "/holiday/addHoliday",
  getAllHolidays: "/holiday/getAllHolidays",
  updateHoliday: "/holiday/updateHoliday/",
  deleteHoliday: "/holiday/deleteHoliday/",
};

export const ACTIVITY = {
  addActivity: "/activity/addActivity",
  getAllActivities: "/activity/getAllActivities",
  getActivityById: "/activity/getActivityById/",
  updateActivity: "/activity/updateActivity/",
  deleteActivity: "/activity/deleteActivity/",
};

export const GALLERY = {
  addGallery: "/gallery/addGallery",
  getAllGalleries: "/gallery/getAllGalleries",
  updateGallery: "/gallery/updateGallery/",
  deleteGallery: "/gallery/deleteGallery/",
};

export const RESULT = {
  getAllExams: "/assessment/getMyAssessments",
  getExamById: "/assessment/getAssessmentById/",
  setExamStatus: "/assessment/setAssessmentStatus/",
  deleteExam: "/assessment/deleteAssessment/",
  upsertMarks: "/assessment/upsertMarks/",
  getPublishedByChild: "/assessment/getPublishedByChild/",
};

export const ASSESSMENT = {
  create: "/assessment/createAssessment",
  update: "/assessment/updateAssessment/",
  setStatus: "/assessment/setAssessmentStatus/",
  delete: "/assessment/deleteAssessment/",
  list: "/assessment/getMyAssessments",
  byId: "/assessment/getAssessmentById/",
  upsertMarks: "/assessment/upsertMarks/",
  publishedByChild: "/assessment/getPublishedByChild/",
};

export const SETTINGS = {
  getModules: "/settings/getModules",
  getAppInfo: "/settings/getAppInfo",
  updateAppInfo: "/settings/updateAppInfo",
  updateModules: "/settings/updateModules",
  getTeacherRules: "/settings/getTeacherRules",
  updateTeacherRules: "/settings/updateTeacherRules",
  teacherDutyDays: "/settings/teacherDutyDays",
  deleteTeacherDutyDay: "/settings/teacherDutyDays/delete/",
  pendingTeacherLeaves: "/settings/pendingTeacherLeaves",
  reviewTeacherLeave: "/settings/reviewTeacherLeave/",
  getFeePolicy: "/settings/getFeePolicy",
  updateFeePolicy: "/settings/updateFeePolicy",
};

export const ADVERTISEMENT = {
  addAdvertisement: "/advertisement/addAdvertisement",
  getAllAdvertisements: "/advertisement/getAllAdvertisements",
  getActiveAdvertisements: "/advertisement/getActiveAdvertisements",
  getAdvertisementById: "/advertisement/getAdvertisementById/",
  updateAdvertisement: "/advertisement/updateAdvertisement/",
  deleteAdvertisement: "/advertisement/deleteAdvertisement/",
};

export const CATEGORY = {
  addCategory: "/category/addCategory",
  getAllCategories: "/category/getAllcategories",
  getCategoryById: "/category/getCategoryById/",
  updateCategory: "/category/updateCategory/",
  deleteCategory: "/category/deleteCategory/",
  toggleStatus: "/category/toggleStatus/",
};
